import React, { useEffect } from 'react';
import HeaderComponent from "../Header/component"
import FooterComponent from "../Footer/component"

import appDevelopment from "../../assets/img/demo/appdevelopment.jpg"
import pageBannerbg from "../../assets/img/page_banner_bg.svg"



import "./styles.scss"

export default function AppDevelopmentComponent() {

  // eslint-disable-next-line no-undef
  useEffect(() => {
    window.scrollTo(0, 0)
  });

  return (
    <>
      <main id="main" className="site-main content-no-spacing web__development-wrapper">
        <HeaderComponent />
        <div className="content">
          <div className="clearfix">
            <section className="page__banner">
               <img className="page__banner-bg" src={pageBannerbg} alt=""/>
              <div className="container">
                <div className="row">
                  <div className="col-lg-12">
                    <div className="entry-banner">
                      <h1 className="entry-title">App Development</h1>
                      <div className="breadcrumb-area">
                        <div className="entry-breadcrumb">
                          <li className="active">
                            <a href="#">Bubble</a>
                          </li>
                          <li className="active">
                            <a href="#">Services</a>
                          </li>
                          <li>
                            <a href="#">App Development</a>
                          </li>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            {/* <section id="page-title" className="page-title-ml content-top-spacing">             
              <div className="wrapper">
                <div className="title">
                  <h1 className="large">Strategic Planning</h1>
                </div>

                <div className="title-opacity">
                  <div className="title-opacity-text">Planning</div>
                </div>

                <div className="description spacer p-top-lg">
                  <p>
                    A business consulting company is involved in the planning, implementation, and education of businesses. We work directly with business owners on developing a business plan, identifying marketing needs and
                    developing the necessary skills for business ownership.
                  </p>
                </div>
              </div>
            </section> */}

            <section className="post-thumb-section">
              <div className="container">
                <div className="row">
                  <div className="col-lg-12">
                    <img className="img-thumbnail img-fluid" src={appDevelopment} alt=""/>
                  </div>
                </div>
                <div className="post-thumb-info">
                  <div className="thumb-text-inner">
                   <p>Mobile apps are the new frontier for business. Obtain a top-of-the-class custom mobile application of any complexity with deep expertise and knowledge of the latest mobile development frameworks.</p>
                  </div>                  
                </div>
              </div>
            </section>

            

          </div>
        </div>
      </main>

       
      <FooterComponent />
    </>
  )
}
